import React from "react";
import PropTypes from "prop-types";

import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import {
    GroupVStack,
    WrapperVStack,
    StyledHR,
} from "shared/components/data-display/drawers/DataGroup";

const DataGroup = ({ groupData, isPadding = true }) => {
    const listLength = groupData[0]?.list?.length;

    return (
        listLength !== 0 && (
            <WrapperVStack isPadding={isPadding}>
                {groupData.map(
                    (data) =>
                        data.list?.length > 0 && (
                            <GroupVStack key={data.label}>
                                <VStack spacing="Zero_25">
                                    <Text
                                        variant="Descriptive_1_1"
                                        color="Gray_2"
                                    >
                                        {data.label}
                                    </Text>

                                    {data.list.map((listData) => (
                                        <Text
                                            key={listData}
                                            variant="Body_2_1"
                                            color="Black"
                                        >
                                            {listData}
                                        </Text>
                                    ))}
                                </VStack>
                                {data.isHr && <StyledHR />}
                            </GroupVStack>
                        )
                )}
            </WrapperVStack>
        )
    );
};

DataGroup.propTypes = {
    groupData: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            list: PropTypes.array,
            isHr: PropTypes.bool,
        })
    ).isRequired,
    isPadding: PropTypes.bool,
};

export default DataGroup;
